export const DATA_FINDER_PLATFORM_TYPES = {
  miniapp: 'wechat_miniprogram',
  web: 'web',
} as const;

export type DataFinderPlatformType = (typeof DATA_FINDER_PLATFORM_TYPES)[keyof typeof DATA_FINDER_PLATFORM_TYPES];

export const resolveDataFinderPlatformType = (search: string): DataFinderPlatformType => {
  const source = new URLSearchParams(search).get('source');
  return source === DATA_FINDER_PLATFORM_TYPES.miniapp
    ? DATA_FINDER_PLATFORM_TYPES.miniapp
    : DATA_FINDER_PLATFORM_TYPES.web;
};
